var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRhpConversation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "30px",
    viewBox: "0 0 33 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icRHPConversation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "109.517584%",
    y1: "-20.0587247%",
    x2: "-26.7473126%",
    y2: "92.4133258%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A30AA5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03D62",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "this-date-has-expired",
    transform: "translate(-29.000000, -671.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 529.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(29.000000, 141.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icRHPConversation",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.23110419e-12,12.7342401 C2.23110419e-12,16.0865531 1.18034068,20.6453938 6.80467192,23.3258586 C6.9825925,23.4105151 7.09555339,23.586063 7.09555339,23.7778216 L7.09555339,30 L14.806643,25.4191318 C14.9007771,25.3585837 15.0148877,25.3232525 15.1225311,25.3364151 L15.3172665,25.3465295 C15.6164835,25.3626018 15.9146945,25.3777042 16.218223,25.3777042 C25.464201,25.3777042 32.5728,19.9422325 32.5728,12.7342401 C32.5728,5.52624774 25.4652334,0 16.2192554,0 C6.97327732,0 2.23110419e-12,5.52624774 2.23110419e-12,12.7342401 Z",
    fill: "url(#linearGradient-1)",
    transform: "translate(16.286400, 15.000000) scale(-1, 1) translate(-16.286400, -15.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3948747,14.304 C11.6029582,14.304 12.5823033,13.3691706 12.5823033,12.216 C12.5823033,11.0628294 11.6029582,10.128 10.3948747,10.128 C9.18679128,10.128 8.20744615,11.0628294 8.20744615,12.216 C8.20744615,13.3691706 9.18679128,14.304 10.3948747,14.304 Z M16.8896,14.304 C18.0976834,14.304 19.0770286,13.3691706 19.0770286,12.216 C19.0770286,11.0628294 18.0976834,10.128 16.8896,10.128 C15.6815166,10.128 14.7021714,11.0628294 14.7021714,12.216 C14.7021714,13.3691706 15.6815166,14.304 16.8896,14.304 Z M23.3843253,14.304 C24.5924087,14.304 25.5717538,13.3691706 25.5717538,12.216 C25.5717538,11.0628294 24.5924087,10.128 23.3843253,10.128 C22.1762418,10.128 21.1968967,11.0628294 21.1968967,12.216 C21.1968967,13.3691706 22.1762418,14.304 23.3843253,14.304 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRhpConversation);
export default __webpack_public_path__ + "static/media/icRHPConversation.14d57a9d8be51e144f70bb1871d3d606.svg";
export { ForwardRef as ReactComponent };